import { render } from "./RoomFeed.vue?vue&type=template&id=f75889c6&scoped=true"
import script from "./RoomFeed.vue?vue&type=script&lang=ts"
export * from "./RoomFeed.vue?vue&type=script&lang=ts"

import "./RoomFeed.vue?vue&type=style&index=0&id=f75889c6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f75889c6"

export default script